package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.merkost.handpass.sharedweb.components.WebInput
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.distinctUntilChanged
import org.jetbrains.compose.web.attributes.InputType

@Composable
fun AdminInput(
    value: String,
    onChange: (String) -> Unit,
    placeholder: String = "",
    type: InputType<String> = InputType.Text,
    widthPx: Int? = null,
    ariaLabel: String? = null,
) {
    WebInput(
        value = value,
        onValueChange = onChange,
        placeholder = placeholder,
        type = type,
        widthPx = widthPx,
        ariaLabel = ariaLabel,
    )
}

@OptIn(kotlinx.coroutines.FlowPreview::class)
@Composable
fun AdminSearchInput(
    initial: String = "",
    onDebouncedChange: (String) -> Unit,
    placeholder: String = "Search…",
    debounceMs: Long = 300,
    widthPx: Int? = 320,
) {
    var raw by remember { mutableStateOf(initial) }
    val flow = remember { MutableSharedFlow<String>(replay = 1) }

    LaunchedEffect(Unit) {
        flow.debounce(debounceMs).distinctUntilChanged().collect(onDebouncedChange)
    }

    AdminInput(
        value = raw,
        onChange = {
            raw = it
            flow.tryEmit(it)
        },
        placeholder = placeholder,
        type = InputType.Search,
        widthPx = widthPx,
    )
}
